import { render, staticRenderFns } from "./ActivityMallRecord.vue?vue&type=template&id=82a51d84&scoped=true&"
import script from "./ActivityMallRecord.vue?vue&type=script&lang=js&"
export * from "./ActivityMallRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a51d84",
  null
  
)

export default component.exports